import React, { Component } from 'react'
import StatusPageMixin from 'containers/shared/StatusPageMixin'
import { connect } from 'react-redux'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'

export class TimedOut extends StatusPageMixin(Component){
  body = () =>
    <div>
      <Typography variant='h6'>Oops! Something went wrong.</Typography>
      <Typography variant='body2'>The request timed out.</Typography>
      <Button variant='contained' color="secondary" onClick={this.goBack(-1)}>Go Back!</Button>
    </div>
}

export default connect()(TimedOut)